import api from './axiosInstance';

export interface LogEntry {
  id: number;
  timestamp: string;
  level: string;
  logger: string;
  message: string;
  exception?: string;
  stackTrace?: string;
}

export interface LogsResponse {
  data: LogEntry[];
  totalCount: number;
  page: number;
  pageSize: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
}

export const logsApi = {
  // Получить все логи
  getLogs: async (params?: {
    fromDate?: string;
    toDate?: string;
    level?: string;
    logger?: string;
    page?: number;
    pageSize?: number;
  }): Promise<LogsResponse> => {
    // Фильтруем пустые параметры
    const filteredParams: any = {};
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          filteredParams[key] = value;
        }
      });
    }
    
    const response = await api.get('/logs', { params: filteredParams });
    return {
      data: response.data.data || response.data,
      totalCount: response.data.totalCount || parseInt(response.headers['x-total-count'] || '0'),
      page: response.data.page || parseInt(response.headers['x-page'] || '1'),
      pageSize: response.data.pageSize || parseInt(response.headers['x-page-size'] || '100'),
      totalPages: response.data.totalPages || 0,
      hasNextPage: response.data.hasNextPage || false,
      hasPreviousPage: response.data.hasPreviousPage || false
    };
  },

  // Получить логи Autopiter
  getAutopiterLogs: async (params?: {
    fromDate?: string;
    toDate?: string;
    page?: number;
    pageSize?: number;
  }): Promise<LogsResponse> => {
    // Фильтруем пустые параметры
    const filteredParams: any = {};
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          filteredParams[key] = value;
        }
      });
    }
    
    const response = await api.get('/logs/autopiter', { params: filteredParams });
    return {
      data: response.data.data || response.data,
      totalCount: response.data.totalCount || parseInt(response.headers['x-total-count'] || '0'),
      page: response.data.page || parseInt(response.headers['x-page'] || '1'),
      pageSize: response.data.pageSize || parseInt(response.headers['x-page-size'] || '100'),
      totalPages: response.data.totalPages || 0,
      hasNextPage: response.data.hasNextPage || false,
      hasPreviousPage: response.data.hasPreviousPage || false
    };
  },

  // Очистить старые логи
  clearOldLogs: async (daysToKeep: number = 30): Promise<{ message: string }> => {
    const response = await api.delete('/logs', { 
      params: { daysToKeep } 
    });
    return response.data;
  }
};
